export default __webpack_public_path__ + "static/media/flag.10f89117.svg";